<template>
    <DNotificationLayout class="dark d-snackbar-layout z-99999 pb-20">
        <DNotification
            :show="showVersionBar"
            type="message"
            @close="onVersionClose"
        >
            <div class="font-medium mb-1">
                Viewing demo version. <span
                    class="underline"
                    @click="revertVersion"
                >Go back</span>
            </div>
        </DNotification>
    </DNotificationLayout>
</template>

<script setup>
    import { DNotification, DNotificationLayout } from '@digistorm/spark'

    const appStore = useAppStore()

    const hideForVersion = ref(null)

    defineExpose({
        reset() {
            hideForVersion.value = null
        },
    })

    const showVersionBar = computed(() => {
        return appStore.draftVersion !== null
            && appStore.draftVersion !== hideForVersion.value
    })

    const onVersionClose = () => {
        hideForVersion.value = appStore.draftVersion
    }

    const revertVersion = () => {
        appStore.resetDraftVersion()
        appStore.restart()
    }
</script>
